var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDialHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.65,25.39a.26.26,0,0,0,.24.29h3V23.3a.37.37,0,0,1,.35-.39h1.28c.48,0,.38.39.38.39v2.38h2.87a.29.29,0,0,0,.29-.27V21L23,17.36l-4.31,3.5Z",
    style: {
      fill: "#9868b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.11,20.61s.38.66,1.14,0l4.7-4,4.35,4c.95.66,1.27,0,1.27,0l-5.73-5.15Z",
    style: {
      fill: "#9868b9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.32 16.59 26.16 16.59 26.16 18.02 27.32 18.98 27.32 16.59",
    style: {
      fill: "#9868b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.85,20l-.27.16c-.53.36-2.45.19-4.05-2.66s-.82-4.67-.26-4.89L12.33,12a1.11,1.11,0,0,0,.45-1.4L10.72,6.86A1.11,1.11,0,0,0,9.3,6.42c0,.07-1.14.61-1.14.7C6.58,8,5.78,9.85,5.87,12.45a15.25,15.25,0,0,0,2.2,6.85,17,17,0,0,0,4.76,5.41,9,9,0,0,0,2,1Z",
    style: {
      fill: "#7e7e7e"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialHome);
export default __webpack_public_path__ + "static/media/dial-home.43a7eb69.svg";
export { ForwardRef as ReactComponent };